import { render } from "./LoaderContent.vue?vue&type=template&id=e8df5c1e&ts=true"
import script from "./LoaderContent.vue?vue&type=script&lang=ts"
export * from "./LoaderContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__